import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const usePlatformSettings = () => {
  const [settings, setSettings] = useState({
    mls_features_enabled: false, // Default to false for safety
    maintenance_mode: false
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/platform-settings`);
        setSettings(response.data);
      } catch (error) {
        console.error('Error fetching platform settings:', error);
        // Keep defaults on error
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, loading };
};
